import script from "./RequestDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestDetail.vue?vue&type=script&setup=true&lang=ts"

import "./RequestDetail.vue?vue&type=style&index=0&id=2df4f2f3&lang=css"

const __exports__ = script;

export default __exports__